import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver-es';

import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { MessageService } from './message.service';
import { TypeToast } from '@models/messagedata';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private messageService: MessageService
  ) { }

  private getFile(url: string): Observable<BlobPart> {
    return this.http.get(url, { responseType: 'blob' });
  }

  private putFile(url: string, body: any): Observable<BlobPart> {
    return this.http.put(url, body, { responseType: 'blob' });
  }

  private setDownload(result: BlobPart, filename: string): void {
    const file = new File([result], filename, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    this.downloadFile(file, filename);

    this.messageService.showToast({
      message: "Download realizado com sucesso.",
      typeToast: TypeToast.SUCCESS,
      description: null
    });
  }

  public downloadFile(file: File, filename: string): void {
    saveAs(file, filename);
  }

  public downloadFileFromRouteWithParameters(route: string, filename: string, body: any): void {
    this.putFile(`${this.baseUrl}${route}`, body).subscribe({
      next: (res: BlobPart) => this.setDownload(res, filename)
    });

  }

  public downloadFileFromRoute(route: string, filename: string): void {
    this.getFile(`${this.baseUrl}${route}`).subscribe({
      next: (res: BlobPart) => this.setDownload(res, filename)
    });

  }

}
